/* Bản quốc tế */

module.exports = {
  // Điều hướng chính
  mainNav: {
    nIndex: 'Trang Chủ',
    nVipCenter: 'Trung tâm hội viên',
    nRecharge: 'Nạp'
  },
  // Các phần liên quan đến đăng nhập và mật khẩu
  userOperate: {
    emailHolder: 'Vui lòng nhập địa chỉ email',
    pswHolder: 'Vui lòng nhập mật khẩu',
    codeHolder: 'Vui lòng nhập mã xác nhận',
    checkpassHolder: 'Vui lòng nhập lại mật khẩu',
    loginText: 'Đăng nhập',
    forgetText: 'Quên mật khẩu',
    registerText: 'Đăng ký',
    loginTips: 'Sử dụng tài khoản bên thứ 3,vui lòng vào game tiến hành liên kết bảo mật',
    loginSuccess: 'Đăng nhập thành công',
    emptyEmail: 'Email tài khoản không được để trống',
    emptyPsw: 'Mật khẩu không được để trống',
    emptyCode: 'Vui lòng nhập 4 chữ số mã xác nhận trên hình',
    emptyCodeNum: 'Vui lòng nhập 4 chữ số mã xác nhận',
    validEmail: 'Vui lòng nhập email hợp lệ',
    validEmailLen: 'Vui lòng nhập từ 6 đến 40 ký tự hoặc chữ số',
    validPsw: 'Vui lòng nhập 6 đến 30 chữ số và ký tự',
    noSamePsw: 'Nhập mật khẩu hai lần không thống nhất',
    emailTitle: 'Email tài khoản',
    pswTitle: 'Mật khẩu',
    newPswTitle: 'Mật khẩu mới',
    checkpassTitle: 'Xác nhận mật khẩu',
    codeTitle: 'Mã xác nhận',
    readAgre: 'Tôi đã đọc và đồng ý',
    agreement: '<<Thỏa thuận đăng ký tài khoản>>',
    goLogin: 'Đến đăng nhập',
    hasAccount: 'Đã có tài khoản',
    readAndAgree: 'Vui lòng đọc và đồng ý<<Thỏa thuận đăng ký tài khoản>>!',
    sendcodeSuccess: 'Mã xác nhận đã gửi thành công, hãy vào email để kiểm tra!',
    forgetStep: {
      stepone: 'Bước 1:Vui lòng nhập tài khoản Gamebao của Bảo Ninh Game',
      steptwo: 'Bước 2: Vui lòng xác nhận thông tin bảo mật',
      stepthree: 'Bước 3: Thiết lập lại mật khẩu',
      stepfour: 'Bước 4: Thiết lập lại mật khẩu thành công'
    },
    nobindTips: 'Chưa liên kết email vui lòng sử dụng Facebook để liên lạc chăm sóc khách hàng lấy lại mật khẩu',
    sendEmail: 'Gửi mã xác nhận',
    nextStep: 'Bước tiếp theo',
    passEmail: 'Thông qua email để tiến hành xác nhận bảo mật',
    newPassSuccess: 'Mật khẩu mới đã thiết lập thành công, vui lòng đăng nhập lại',
    loginPlatform: 'Đăng nhập',
    confirmText: 'Xác nhận',
    loadingText: 'Đang đăng ký, vui lòng đợi...',
    registerSuccess: 'Chúc mừng đăng ký thành công !<br/> Để bảo vệ tài khoản an toàn hãy liên kết email bảo mật',
    bindAndLogin: 'Liên kết email và đăng nhập',
    bindSuccess: 'Liên kết email thành công',
    confirmUnbindTips: 'Bỏ liên kết email sẽ khiến tài khoản không được bảo vệ an toàn, bạn xác nhận hủy liên kết email bảo mật?',
    unbindSuccess: 'Hủy thành công email bảo mật',
    sendcode: 'Gửi mã xác nhận',
    sending: 'Đang gửi',
    loadingTextDefault: 'Đang tải...'
  },
  //Các nút liên quan đến thao tác của user
  userCenter: {
    bLogin: 'Đăng nhập',
    bRegister: 'Đăng ký',
    bForget: 'Quên mật khẩu',
    confirmLogout: 'Bạn xác nhận muốn thoát?',
    cancelText: 'Hủy',
    confirmText: 'Xác nhận',
    update: 'Đăng nhập đã quá hạn, vui lòng đăng nhập lại!',
    errorText: 'Yêu cầu thất bại, hãy thử lại'
  },
  //Trang chủ
  indexPage: {
    tAllGames: 'Toàn bộ game',
    enterWebsite: 'Vào Trang chủ'
  },
  // Trung tâm hội viên
  vipCenterPage: {
    sideNav: {
      base: 'Thông tin cơ bản',
      bind: 'Liên kết email bảo mật',
      unbind: 'Hủy liên kết email bảo mật',
      record: 'Tìm kiếm ghi chép',
      modify: 'Thay đổi mật mã',
      signout: 'Thoát đăng nhập'
    },
    breadcrumb: {
      current: 'Vị trí hiện tại',
      aNavgation: 'Trung tâm hội viên'
    },
    base: {
      myAccount: 'Tài khoản của tôi',
      myIcons: 'BAO của tôi',
      bind: 'Liên kết email',
      noBind: 'Email chưa liên kết'
    },
    bindTips:'Nhắc nhở:sau khi liên kết email bảo mật có thể tiến hành tìm lại mật khẩu, thay đổi mật khẩu.<br/>Để an toàn cho tài khoản, hãy thực hiện ngay.',
    unbindTips: 'Nhắc nhở: Thông qua liên kết email bảo mật có thể tìm lại mật khẩu khi quên.<br/> Đề nghị không hủy liên kết an toàn',
    totalFont: 'Tổng số trang',
    rechargefail: 'Chưa thanh toán', // -1
    rechargeSuccess: 'Nạp thành công', // 2
    testSuccess: 'Kiểm tra thành công', // -3
    rechargeRecord: {
      noRecord: 'Bạn chưa có bất kỳ ghi nhận nào về Nạp tiền, hãy mau tiến hành Nạp nhé~',
      rechargeText: 'Nạp',
      title: 'Ghi chép nạp',
      orderId: 'Mã số giao dịch',
      payAmount: 'Tiền nạp',
      payState: 'Trạng thái nạp',
      payWay: 'Phương thức nạp',
      payTime: 'Thời gian nạp'
    },
    exchangeRecord: {
      noRecord: 'Bạn vẫn chưa tiến hành nạp nên không có ghi chép nạp, mau tiến hành nạp nhé ~',
      exchangText: 'Nạp game',
      title: 'Lịch sử nạp game',
      name: 'Tên game',
      server: 'Tên server game',
      exchangeAmount: 'Số tiền nạp game',
      getAmount: 'Nhận được',
      exchangeTime: 'Thời gian nạp game',
      rechangeTime: 'Thời gian nạp'
    },
    modifySteps: {
      stepone: 'Xác nhận thông tin bảo mật',
      steptwo: 'Đổi mật khẩu đăng nhập',
      stepthree: 'Thay đổi mật khẩu thành công'
    }
  },
  // Nạp
  recharge: {
    sideNav: {
      recharge: 'Nạp vào tài khoản',
      exchange: 'Nạp vào game'
    },
    breadcrumb: {
      current: 'Vị trí hiện tại',
      aNavgation: 'Nạp'
    },
    myIcons: 'Số BAO của tôi',
    question: 'Khi nạp gặp vấn đề vui lòng liên hệ Chăm sóc khách hàng',
    method: 'Phương thức nạp',
    meal: 'COMBO Nạp',
    rechargeBtn: 'Nạp',
    exchangeBtn: 'Xác nhận nạp',
    chooseRole: 'Chọn nhân vật',
    gameHolder: 'Chọn trò chơi',
    serverHolder: 'Chọn server',
    roleHolder: 'Vui lòng chọn nhân vật trong trò chơi',
    noRole: 'Bạn không có nhân vật nào trong server này, vui lòng qua server khác để thực hiện',
    tips: 'Nhắc nhở',
    noClose: 'Trước khi thanh toán thành công vui lòng không đóng cửa sổ này, thanh toán thành công tùy theo tình trạng của bạn nhấp chuột vào các nút dưới đây:',
    choose: 'Vui lòng hoàn thành thanh toán ở trang mới vừa mở rồi tiếp tục lựa chọn',
    successBuy: 'Hoàn tất thanh toán',
    failBuy: 'Thanh toán gặp vấn đề',
    exchangeSuccess: 'COMBO Nạp game thành công, vào game dể kiểm tra nhé~',
    exchangeFail: 'Kỳ lạ! Nạp game sao lại thất bại rồi, tí nữa thử nạp lại nhé!'
  },
  modify: {
    tips: 'Đổi mật khẩu cần liên kết email bảo mật!',
    bindText: 'Liên kết email'
  },
  moblie: {
    registering: 'Đang đăng ký...',
    readFirst: 'Vui lòng đọc trước điều khoản đăng ký tài khoản',
    connectNav: 'Liên lạc chăm sóc khách hàng',
    agreement: 'Điều khoản đăng ký',
    unbindText: 'Hủy liên kết bảo mật',
    bindText: 'Xác nhận liên kết bảo mật',
    unbindTips: 'Thông qua liên kết email bảo mật có thể tìm lại mật khẩu khi quên<br/> Vì sự an toàn của tài khoản, kiến nghị không hủy liên kết bảo mật.',
    bindTips:'Liên kết email bảo mật có thể tìm lại mật khẩu khi quên, thay đổi mật mã nếu muốn <br/> Kiến nghị liên kết email bảo mật để bảo vệ tài khoản.',
    accountHolder: 'Vui lòng nhập tài khoản email',
    topPullText: 'Làm mới',
    topDropText: 'Giải nén cập nhật',
    topLoadingText: 'Đang tải...',
    bottomPullText: 'Đang tải',
    bottomDropText: "Giải nén tải về",
    bottomLoadingText: "Đang tải...",
    noMore: 'Không còn gì nữa...',
    pleaseChoose: 'Vui lòng chọn phương thức nạp và COMBO Nạp',
    exchangeing: 'Đang nạp game...',
    forget: {
      stepone: 'Vui lòng nhập tài khoản Gamebao',
      steptwo: 'Kiểm tra thông tin bảo mật',
      stepthree: 'Đặt lại mật khẩu đăng nhập',
      stepfour: 'Đặt lại mật khẩu thành công'
    }
  },
  order: {
    title: 'Xác nhận đơn hàng',
    account: 'Nạp tài khoản',
    meal: 'Nạp COMBO',
    way: 'Phương thức Nạp',
    amount: 'Số tiền thanh toán',
    cancelText: 'Hủy',
    confirmText: 'Xác nhận thanh toán'
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/vn.js